// components/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header.jsx';
import Landing from './components/Landing.jsx';
import ReleaseNotes from './components/release-notes/ReleaseNotes.jsx';
import Login from './components/Login.jsx'; // Import the Login component
import ProtectedRoute from './components/ProtectedRoute.jsx'; // Import the ProtectedRoute component
import Consumption from './components/consumption-dash/Consumption.jsx';

function App() {
  return (
    <Router>
      {/* Include the Header component so it appears on all pages */}
      <Header />

      {/* Route Definitions */}
      <div className="pt-12"> {/* Padding top to prevent content from being hidden under the fixed header */}
        <Routes>
          {/* Public route for the login page */}
          <Route path="/login" element={<Login />} />
          
          {/* All other routes are protected and require authentication */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Landing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/release-notes"
            element={
              <ProtectedRoute>
                <ReleaseNotes />
              </ProtectedRoute>
            }
          />
                    <Route
            path="/consumption"
            element={
              <ProtectedRoute>
                <Consumption />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;